import React from "react";
import { isDynamicDateTimeInput } from "shared/components/pillar-form/dynamic-component/isDynamicDateTimeInput";
import { isDynamicSelectInput } from "shared/components/pillar-form/dynamic-component/isDynamicSelectInput";
import { normalizeDynamicSelectChoices } from "shared/components/pillar-form/dynamic-component/normalizeDynamicSelectChoices";
import { PillarFormDynamicInputComponentsMapper } from "shared/components/pillar-form/dynamic-component/PillarFormDynamicInputComponentsMapper";
import { resolveDynamicDateTimeType } from "shared/components/pillar-form/dynamic-component/resolveDynamicDateTimeType";
import { type PillarFormInputComponentConfig } from "shared/components/pillar-form/PillarFormInputComponentConfig";

interface PillarFormDynamicInputComponentProps {
  element: PillarFormInputComponentConfig;
  className?: string;
}

export const PillarFormDynamicInputComponent: React.FC<
  PillarFormDynamicInputComponentProps
> = ({ element, className = "w-full mb-1" }) => {
  // Common props for all components. There is no required marker on
  // PillarFormInputWrapper, so the label carries it - otherwise a definition
  // can require a field the admin has no way to spot before saving.
  const label = element.title ?? element.name;

  const commonProps = {
    name: element.name,
    label: element.isRequired ? `${label} *` : label,
    testid: element.testid,
  };

  if (isDynamicSelectInput(element)) {
    return (
      <div className={className}>
        <PillarFormDynamicInputComponentsMapper.Select
          {...commonProps}
          additionalClasses="w-full"
          placeholder={element.placeholder as string | undefined}
          localOptionsList={normalizeDynamicSelectChoices(element)}
          searchable={element.searchable as boolean | undefined}
          multiple={element.multiple as boolean | undefined}
        />
      </div>
    );
  }

  if (isDynamicDateTimeInput(element)) {
    return (
      <div className={className}>
        <PillarFormDynamicInputComponentsMapper.DateTime
          {...commonProps}
          dateTimeType={resolveDynamicDateTimeType(element)}
        />
      </div>
    );
  }

  // Default to text input
  return (
    <div className={className}>
      <PillarFormDynamicInputComponentsMapper.Text {...commonProps} />
    </div>
  );
};
